import { ProfileTemplate } from "@/components/Templates";
import { useProfilePage } from "@/hooks/useProfilePage";

export function ProfilePage() {
  const profile = useProfilePage();

  return <ProfileTemplate {...profile} />;
}
